import type { TextFieldProps } from "@braintrust/braintrust-ui-components";
import { TextField } from "@braintrust/braintrust-ui-components";

export const inputFieldStyles = {
  "&:not(.Mui-focused):not(.Mui-error)": {
    "&:not(:hover) fieldset": {
      borderColor: "var(--grey-4)",
    },
    "&:hover fieldset": {
      borderColor: "var(--grey-3)",
    },
  },
} as const;

const textareaStyles = {
  ".MuiOutlinedInput-root": {
    padding: "12px 16px",
  },
  textarea: {
    padding: "0 !important",
  },
} as const;

export type InterviewStyledTextFieldProps = TextFieldProps;

export const InterviewStyledTextField = (
  props: InterviewStyledTextFieldProps,
) => {
  return (
    <TextField
      {...props}
      sx={{
        " .MuiInputBase-root": {
          ...inputFieldStyles,
        },
        ...props.sx,
        ...(props.multiline ? textareaStyles : {}),
      }}
    />
  );
};
